export default "__VITE_ASSET__2349b609__"